import React from "react";
import CommonManagementSection from "./CommonManagementSection";
import OpportunitiesJobSection from "./OpportunitiesJobSection";

class ProjectManagementSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }
    
    render() {
        return (
            <div id='projectMngmnt' className='lndSolutionEachSec'>
                <div className='lndSoltopHead'>
                    <h3>Project Management</h3>
                    <p>Revolutionize the way you manage projects and record each activity for future reference.</p>
                </div>
                <div className='specialGridCol'>
                    <CommonManagementSection sectionType={"PROJECT"} />

                    <div className='lndSPCol lndSolRightInfoBlk'>
                        <h4>Inculcate Scalability, Accountability, Sustainability and Collaboration</h4>
                        <ul className='lndSolLists'>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolProjIco-1.svg"} alt='' /></figure>
                                <div>
                                    <h5>One Window Collaboration</h5>
                                    <p>Everyone : Volunteers, Participants, Partners, Donors</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolProjIco-2.svg"} alt='' /></figure>
                                <div>
                                    <h5>User Rights Management</h5>
                                    <p>Manage Admins, Participants</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolProjIco-3.svg"} alt='' /></figure>
                                <div>
                                    <h5>Manage Applications</h5>
                                    <p>Conduct Event, Training, Expedition, Fund Raise</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolProjIco-4.svg"} alt='' /></figure>
                                <div>
                                    <h5>Auto Updates and Alerts</h5>
                                    <p>Eliminate repetitive tasks and manual followups</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolProjIco-5.svg"} alt='' /></figure>
                                <div>
                                    <h5>Trust with Transparency</h5>
                                    <p>Record every action or activity for reference</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <OpportunitiesJobSection />
            </div>
        );
    }
}

export default ProjectManagementSection;